module.exports = __webpack_public_path__ + "static/img/encore.55614aba.png";